// src/store/index.js
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/reducer';
import { uidConfigReducer } from './uidConfig/reducer';
import { io } from 'socket.io-client';
import { getStoredToken, getStoredUser } from '../utils/authStorage';

const rootReducer = combineReducers({
  authSlice: authReducer, // Изменили ключ на authSlice для согласованности
  uidConfig: uidConfigReducer, // SPRINT_10: Кэширование конфигурации UID
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

// Инициализация WebSocket поверх socket.io
let socket = null;
export const initSocket = (tokenArg, userIdArg) => {
  if (socket) {
    return socket;
  }
  const storedUser = getStoredUser() || {};
  const storedToken = getStoredToken() || '';
  const token = tokenArg || storedToken;
  const userId = userIdArg || storedUser?.id;

  let baseUrl;
  if (process.env.NODE_ENV === 'development') {
    const host = window.location.hostname;
    baseUrl = `http://${host}:3000`;
  } else {
    baseUrl = window.location.origin;
  }

  let projectSlug = undefined;
  try {
    const parts = window.location.pathname.split('/').filter(Boolean);
    if (parts.length >= 2 && parts[0] === 'p') projectSlug = parts[1];
  } catch (_) {
    /* noop */
  }

  const wsUrl = baseUrl;

  if (!token) {
    console.error('[WS] No token provided for WebSocket connection');
  }
  if (!userId) {
    console.error('[WS] No userId provided for WebSocket connection');
  }
  if (!token || !userId) {
    return null;
  }

  socket = io(`${wsUrl}/ws`, {
    path: '/socket.io',
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 10000,
    query: { token, userId, project: projectSlug },
    ...(process.env.NODE_ENV === 'development' && {
      forceNew: true,
      upgrade: true,
      rememberUpgrade: false,
    }),
  });

  try {
    socket.on('connect', () => {
      try {
        window.dispatchEvent(new CustomEvent('ws:connect', { detail: { id: socket.id } }));
      } catch (e) {
        console.error('[WS] Error in connect handler:', e);
      }
    });

    socket.on('disconnect', (reason) => {
      try {
        window.dispatchEvent(new CustomEvent('ws:disconnect', { detail: { reason } }));
      } catch (e) {
        console.error('[WS] Error in disconnect handler:', e);
      }
    });

    socket.on('connect_error', (err) => {
      try {
        console.error('[WS] Connection error:', err);
        window.dispatchEvent(
          new CustomEvent('ws:error', {
            detail: { message: err?.message || String(err) },
          }),
        );
      } catch (e) {
        console.error('[WS] Error in connect_error handler:', e);
      }
    });

    socket.on('reconnect_error', (error) => {
      console.error('[WS] Reconnection error:', error);
    });

    socket.on('reconnect_failed', () => {
      console.error('[WS] Reconnection failed');
    });

    try {
      if (process.env.NODE_ENV !== 'production') {
        window.dispatchEvent(
          new CustomEvent('ws:info', {
            detail: {
              url: baseUrl,
              namespace: '/ws',
              socketId: socket.id,
              connected: socket.connected,
            },
          }),
        );
      }
    } catch (e) {
      console.error('[WS] Error in info event:', e);
    }
  } catch (e) {
    console.error('[WS] Error setting up socket event handlers:', e);
  }
  return socket;
};

export const getSocket = () => socket;
